module.exports = __webpack_public_path__ + "static/media/head-faubourg-home.a12edecd.png";